(function ($) {

    $(document).ready(function ($) {
        listenToPopupCloseEvent(() => {
            history.pushState({}, "", "#");
        });

        window.addEventListener('hashchange', (e) => {
            if (e.type === 'hashchange') {
                triggerPoups();
            }
        });

        // Init
        setTimeout(() => triggerPoups(), 1500);
    });

    function triggerPoups() {
        if (typeof window.location.hash === "undefined") {
            return;
        }

        const popups = Object.keys(popupData);

        popups.forEach(function (anchor) {
            if (window.location.hash === '#' + anchor) {
                openPopup(anchor);
                console.log('Trigger Elementor "' + anchor + '" Popup');
            }
        });
    }

    /**
     * Popups Interface.
     */

    function listenToPopupCloseEvent(cb) {
        $('.pum').on('pumAfterClose', cb);
    }

    function openPopup(type) {
        const popupId = popupData[type]
        if (popupId) {
            PUM.open(popupId)
            $('#pum-' + popupId).popmake('reposition');
        }
    }

    function closePopup() {
        history.pushState({}, "", "#");
    }

    window.closePopup = closePopup;

})(window.jQuery);
